import * as React from 'react';
import './InterestsPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as InterestActions from '../../../actions/interests';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { LookupsLayout } from '../../index';
interface IInterestsPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  interest: Dtos.Interest[];
  loadingInterests: boolean;
  loadInterestsSuccess: boolean;
  loadInterestsFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface IInterestsPageActions {
  clearInterests: InterestActions.IInterestClearActionCreator;
  loadInterests: InterestActions.IInterestLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: InterestActions.IInterestFilterActionCreator;
}
type InterestsPageProps = IInterestsPageProps & IInterestsPageActions;
class InterestsPage extends React.PureComponent<InterestsPageProps, any> {
  constructor(props: InterestsPageProps) {
    super(props);
    this.clearInterests = this.clearInterests.bind(this);
  }
  componentDidMount() {
    const {
      loadInterests
    } = this.props;
    loadInterests();
  }
  componentWillReceiveProps(nextProps: InterestsPageProps) {}
  componentDidUpdate(prevProps: InterestsPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: InterestsPageProps) {}
  componentWillUnmount() {
    this.clearInterests();
  }
  clearInterests() {
    this.props.clearInterests();
  }
  showInterests(): boolean {
    const {
      loadingInterests,
      loadInterestsSuccess
    } = this.props;
    if (!loadingInterests && loadInterestsSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingInterests
    } = this.props;
    return <LookupsLayout loading={loadingInterests} permission={Dtos.Permission.InterestsView} data-sentry-element="LookupsLayout" data-sentry-component="InterestsPage" data-sentry-source-file="InterestsPage.tsx">
            {this.renderContent()}
        </LookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Interests</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InterestsCreate) && <Link className={"btn btn-primary"} url={"/settings/general/interests/create"}>Create</Link>}
                </div>
            </div>
            {!this.showInterests() ? "Loading Interests" : null}
            {this.showInterests() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      interest
    } = this.props;
    if (!interest || interest.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no interests to view.</span>
            </div>;
    }
    const showPagination = interest.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={interest} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : interest.length} pageSize={showPagination ? undefined : interest.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no interest to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/general/interests/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: InterestsPageProps): IInterestsPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.interests.formFilter,
    interest: state.interests.formFilteredData,
    loadingInterests: state.interests.loadState && state.interests.loadState.status == RequestState.Pending,
    loadInterestsSuccess: state.interests.loadState && state.interests.loadState.status == RequestState.Success,
    loadInterestsFailure: state.interests.loadState && state.interests.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): IInterestsPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadInterests: bindActionCreators(InterestActions.LoadInterest, dispatch),
    clearInterests: bindActionCreators(InterestActions.Clear, dispatch),
    filter: bindActionCreators(InterestActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InterestsPage);